(function () {
  'use strict';

  var overlay    = document.getElementById('hvac-pm-overlay');
  var openBtn    = document.getElementById('hvac-pm-open-btn');
  var closeBtn   = document.getElementById('hvac-pm-close');
  var form       = document.getElementById('hvac-pm-form');
  var submitBtn  = document.getElementById('hvac-pm-submit');
  var errorMsg   = document.getElementById('hvac-pm-error');
  var successMsg = document.getElementById('hvac-pm-success');
  var nameEl     = document.getElementById('hvac-pm-product-name');
  var priceEl    = document.getElementById('hvac-pm-product-price');

  if (!overlay || !openBtn) return;

  function getProductData() {
    var el = document.getElementById('hvac-product-print-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function openModal() {
    var d = getProductData();
    if (nameEl)  nameEl.textContent  = (d && d.title) || document.title || '';
    if (priceEl) priceEl.textContent = (d && d.price) || '';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (form)       { form.reset(); form.style.display = ''; }
    if (successMsg) { successMsg.style.display = 'none'; successMsg.textContent = ''; }
    if (errorMsg)   { errorMsg.style.display   = 'none'; errorMsg.textContent   = ''; }
    if (submitBtn)  { submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
  }

  openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorMsg.style.display = 'none';
    errorMsg.textContent   = '';

    var name      = document.getElementById('hvac-pm-name').value.trim();
    var email     = document.getElementById('hvac-pm-email').value.trim();
    var compPrice = document.getElementById('hvac-pm-comp-price').value.trim();
    var compLink  = document.getElementById('hvac-pm-comp-link').value.trim();
    var comments  = document.getElementById('hvac-pm-comments').value.trim();
    var d         = getProductData();

    if (!name || !email || !compPrice || !compLink) {
      errorMsg.textContent   = 'Please fill in all required fields.';
      errorMsg.style.display = 'block';
      return;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      errorMsg.textContent   = 'Please enter a valid email address.';
      errorMsg.style.display = 'block';
      return;
    }

    var cfg        = document.getElementById('hvac-email-cfg');
    var webhookUrl = cfg && cfg.dataset.webhookUrl;

    if (!webhookUrl || webhookUrl === 'PASTE_YOUR_MAKE_WEBHOOK_URL_HERE') {
      errorMsg.textContent   = 'Price match service is not configured. Please contact the store.';
      errorMsg.style.display = 'block';
      return;
    }

    submitBtn.disabled    = true;
    submitBtn.textContent = 'Sending…';

    fetch(webhookUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type:            'price-match',
        subject:         'Price Match Request – ' + ((d && d.title) || document.title),
        product:         (d && d.title) || document.title,
        ourPrice:        (d && d.price) || '',
        productUrl:      window.location.href,
        name:            name,
        email:           email,
        competitorPrice: compPrice,
        competitorLink:  compLink,
        comments:        comments
      })
    })
      .then(function (res) {
        if (res.ok) {
          form.style.display       = 'none';
          successMsg.style.display = 'block';
          successMsg.textContent   = "Your price match request has been submitted! We’ll get back to you shortly.";
        } else {
          throw new Error('Server error: ' + res.status);
        }
      })
      .catch(function (err) {
        submitBtn.disabled    = false;
        submitBtn.textContent = 'Submit';
        errorMsg.textContent  = 'Failed to submit. Please try again.';
        errorMsg.style.display = 'block';
        console.error('[hvac-pm] submit error:', err);
      });
  });

})();
